export * from '@primeuix/themes/lara/accordion';
export { default } from '@primeuix/themes/lara/accordion';
